module.exports = __webpack_public_path__ + "assets/images/calendar-day.e6bad0cfdf4a9b85d76e66b63a4db7c4.svg";